// components
import GridAction from '../../components/common/GridAction';

// Utils
import { dateHeader, formatCellDate } from './timeModeCell';

// Types
import { AppPermissions } from '../../constants/Permissions';
import { Button } from '@mui/material';
import { CompanyTypes } from '../../types/CompanyTypes';

// export const makeCompaniesColumn = (onDelete: (id: string) => void, onEdit: (company: Company) => void) => {
export const makeCompaniesColumn = (
  onEdit: (id: string, carrierId?: string | null) => void,

  openRelationPopup: { (id: string): void; (arg0: any): void },
) => {
  const col = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={() => onEdit(row.original.id, row.original.carrierId)}
            editPermission={AppPermissions.Company.Edit}
            // onDeleted={() => onDelete(row.original.id)}
            deletePermission={AppPermissions.Company.Delete}
            row={row.original}
            id={row.original.id}
          />
        );
      },
    },
    {
      header: 'Company Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 220,
    },
    {
      header: 'Type',
      accessorKey: 'companyTypeId',
      size: 150,
      cell: ({ row }) => {
        const { companyTypeDescr, companyTypeId } = row.original;
        const typeLabel = companyTypeDescr || CompanyTypes[companyTypeId] || ' ';
        return <span>{typeLabel}</span>;
      },
    },
    {
      header: 'Carrier IATA',
      accessorKey: 'carrierIataCode',
      size: 120,
    },
    {
      header: 'Broker Code',
      accessorKey: 'brokerCode',
      size: 120,
    },
    {
      header: 'Email Domain',
      accessorKey: 'domains',
      size: 200,
      cell: ({ row }) => {
        const domains = row.original.domains;
        return <span>{Array.isArray(domains) && domains.length ? domains.join(', ') : ''}</span>;
      },
    },
    {
      header: 'View Relations',
      size: 150,
      cell: ({ row }) => (
        <Button variant='text' style={{ textDecoration: 'underline' }} size='small' onClick={() => openRelationPopup(row.original.id)}>
          View Relations
        </Button>
      ),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;

  return col;
};
